import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey9 } from 'approot/shared/styles/colours.style';
import {
  font16,
  fontWeightMedium,
  Heading20,
  LinkStyled,
} from 'approot/shared/styles/typography.style';
import { spacing32 } from '../styles/spacing.style';

type ErrorContainerProps = {
  $paddingTop?: number;
};
export const ErrorContainer = styled.div<ErrorContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ $paddingTop = 100 }) => rem($paddingTop)} 0 0 0;
  text-align: center;
  max-width: ${rem(500)};
  margin: auto;

  ${LinkStyled} {
    ${font16}
  }

  svg {
    margin-bottom: ${rem(spacing32)};
  }
`;

export const ErrorTitle = styled(Heading20).attrs({
  colour: grey9,
})`
  font-weight: ${fontWeightMedium};
  text-align: center;
`;
